import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Range, getTrackBackground } from "react-range"

const Container = styled.div`
  position: relative;
  margin: 0 8px;
`
const Thumb = styled.div`
  height: ${props => props.theme.collectionFilter.priceFilterThumb.height};
  width: ${props => props.theme.collectionFilter.priceFilterThumb.width};
  background: ${props => props.theme.colors.white};
  border-radius: 2px;
  border: 1px solid
    ${props =>
      props.dragged
        ? props.theme.colors.dusk
        : props.theme.collectionFilter.themeColor}};
`
const Track = styled.div`
  align-self: center;
  border: 1px solid ${props => props.theme.colors.grey35};
  border-radius: 2px;
  height: ${props => props.theme.collectionFilter.priceFilterTrack.height};
  width: ${props => props.theme.collectionFilter.priceFilterTrack.width};
`
/**
 * Multi-thumb range Slider
 * @param  {array} filteredValues ([min, max]) - set initial slider min/max values
 * @param  {integer} min - minimum value of range slider
 * @param  {integer} max - maximum value of range slider
 * @param  {function} onChange - callback when slider value changes
 */
const RangeSlider = ({ filteredValues, min, max, onChange }) => {
  const [values, setValues] = useState(filteredValues)

  useEffect(() => {
    return () => {}
  }, [])

  const updateRangeValues = values => {
    setValues([values[0], values[1]])
    onChange(values)
  }

  return (
    <Container>
      <Range
        values={values}
        min={min}
        max={max}
        step="1"
        onChange={updateRangeValues}
        allowOverlap={false}
        renderThumb={({ props, isDragged }) => (
          <Thumb dragged={isDragged} {...props} />
        )}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "15px",
              display: "flex",
              width: "100%"
            }}
          >
            <Track
              ref={props.ref}
              style={{
                background: getTrackBackground({
                  values: values,
                  colors: ["#fff", "#2468b2", "#fff"],
                  min: min,
                  max: max
                })
              }}
            >
              {children}
            </Track>
          </div>
        )}
      />
    </Container>
  )
}

RangeSlider.propTypes = {
  filteredValues: PropTypes.array.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func
}
export default RangeSlider
